import { useLocation, useSearchParams } from 'react-router-dom';
import HomePage from '../pages/page/index';
import { useCallback, useEffect, useState } from 'react';
import { AxiosError } from 'axios';
import { Config, Data } from '@measured/puck';
import {
  checkoutService,
  GetPreCheckoutUpSellPayload,
  handleCapi,
  // LoadingPage,
  ShippingMethod,
  showNotification,
  StatusCode,
  AxonTracker,
  extractAndUseTrackers,
  GoogleAdsTracker,
  GTMTracker,
  GTMTrackerCustom,
  GTMTrackerForThakyouPage,
  NewsBreakTracker,
  RetentionPixelTracker,
  SnapPixelTracker,
  TripleWhaleTracker,
  CheckoutSkeleton,
} from 'shared-components';
import checkoutConfig from 'puck/checkout-puck-config';
import { ConvertBase64ToJson } from 'shared-components';
import { v4 as uuidv4 } from 'uuid';
import { isEmpty } from 'lodash';
import { EventPublisher } from 'shared-components/src/page-builder/utils/publishEvent';
import ErrorMessage from 'components/error-message';
import { IErrorResponse } from 'shared-components/src/page-builder/interface/apiInterface';
import { setStoreData } from 'shared-components/src/page-builder/redux/slices/storeSlice';
import { useAppSelector } from 'hooks/reduxHooks';
import { useDispatch } from 'react-redux';
import { PageType } from 'utils/constant';
import {
  setApplePay,
  setCartData,
  setGooglePay,
  setIsCartApiLoading,
  setIsCartLoading,
  setPromoCodes,
} from 'shared-components/src/page-builder/redux/slices/cartSlice';
import { Cart } from 'shared-components/src/page-builder/interface/checkoutInterface';
import {
  setCurrentUpsellData,
  setPostUpsellData,
  setSmartUpsellFunnelID,
  setUpsellData,
  setSelectedUpsellItems,
  setSelectedVariantForSingleProduct,
} from 'shared-components/src/page-builder/redux/slices/postUpsellSlice';
import {
  setPreUpsellData,
  setPreUpsellLoading,
} from 'shared-components/src/page-builder/redux/slices/preUpsellSlice';
import {
  setAvailableShippingMethods,
  setCurrentPageFunnelId,
  setNextPageConfig,
  setPageId,
  setSelectedShippingMethod,
  setApiLoading,
  setIsDeclinePopup,
  setIsSetShippingApiLoading,
  setPurchaseToken,
} from 'shared-components/src/page-builder/redux/slices/checkoutSlice';
import { postUpsellPage } from 'shared-components/src/page-builder/utils/postUpsell';
import {
  setCallMetaApi,
  setSalexTaxEnabled,
  setCheckoutErrorMessage,
  setSubmitSuccess,
  setCalculatedFeeEnabled,
} from 'shared-components/src/page-builder/redux/slices/commonSlice';
import { setCountriesList } from 'shared-components/src/page-builder/redux/slices/CountryInfoSlice';
import { setOrderDetails } from 'shared-components/src/page-builder/redux/slices/orderDetailsSlice';
import {
  setIsLoading,
  setShowPopup,
} from 'shared-components/src/page-builder/redux/slices/postUpsellStateSlice';
import { Tracker } from 'shared-components/src/page-builder/utils/trackers/trackers';
import { ExtendedRootFieldProps } from 'shared-components/src/page-builder/interface/pageInterface';

// Global store for shipping data
let globalShippingData: ShippingData | null = null;
const shippingDataListeners: ((_data: ShippingData) => void)[] = [];

const setGlobalShippingData = (data: ShippingData) => {
  globalShippingData = data;
  shippingDataListeners.forEach(listener => listener(data));
};

// Immediately attach the function to window when module loads
window.setGlobalShippingData = setGlobalShippingData;

interface ShippingData {
  Address1: string;
  Address2: string;
  City: string;
  CountryCode: string;
  FirstName: string;
  LastName: string;
  Organization: string;
  ProvinceCode: string;
  Zip: string;
  Email: string;
  PhoneNumber: string;
}

// Type declaration for global window property
declare global {
  interface Window {
    setGlobalShippingData?: (_data: ShippingData) => void;
  }
}

const Funnelish = () => {
  const { state } = useLocation();
  const dispatch = useDispatch();
  const storeData = useAppSelector(state => state.store.storeData);
  const [searchParams] = useSearchParams();
  const purchaseToken = useAppSelector(state => state.checkout.purchaseToken);
  const navStateID = state?.id;
  const shopId = searchParams.get('store');
  const cartId = searchParams.get('cart');
  const funnelishId = searchParams.get('funnelishId');
  const eventToken = searchParams.get('event-token');
  const isMockApi = searchParams.get('use-mock-api') === 'true';
  const [error, setError] = useState<string>('');
  const [loading, setLoading] = useState<number>(0);
  const [puckConfig, setPuckConfig] = useState<Config | null>();
  const [puckData, setPuckData] = useState<Data>();
  const cartData = useAppSelector(state => state.cart.cartData);
  const thankyouPagePixelStoreIds = ['0x9suh-gz'];
  const [pixelEvent, setPixelEvent] = useState<Tracker[]>([]);
  const publish = EventPublisher.getInstance().publish;
  const puckRootData = puckData?.root?.props as ExtendedRootFieldProps;
  const input1: { shopId: string } = { shopId: shopId || '' };
  const isThankYouPage = state?.pageType === 'confirmation';
  const [metaTickTokTracker, setMetaTikTokTracker] = useState<{
    meta: string[];
    tiktok: string[];
  }>({
    meta: [],
    tiktok: [],
  });
  const [pixelData, setPixelData] = useState({
    isEventHoisted: false,
    phxRequestId: '',
  });

  const resetState = () => {
    dispatch(setCartData(null));
    dispatch(setApplePay(null));
    dispatch(setStoreData(null));
    dispatch(setApiLoading(false));
    dispatch(setAvailableShippingMethods([]));
    dispatch(setSelectedShippingMethod(null));
    dispatch(
      setNextPageConfig({
        id: '',
        pageType: '',
        pageVisiblity: '',
      }),
    );
    dispatch(setCountriesList([]));
    dispatch(setPreUpsellData(null));
    dispatch(setPostUpsellData(null));
    dispatch(setOrderDetails([]));
    dispatch(setPurchaseToken(''));
    dispatch(setCallMetaApi(false));
    dispatch(setSalexTaxEnabled(false));
    dispatch(setCheckoutErrorMessage(''));
    dispatch(setIsDeclinePopup(false));
    dispatch(setSubmitSuccess(false));
    dispatch(setIsCartLoading(false));
    dispatch(setPromoCodes(null));
    dispatch(setIsSetShippingApiLoading(0));
    dispatch(setCurrentUpsellData(null));
    dispatch(setIsLoading(false));
    dispatch(setUpsellData(null));
    dispatch(setSelectedUpsellItems([]));
    dispatch(setShowPopup(false));
    dispatch(setSelectedVariantForSingleProduct(null));
    dispatch(setSmartUpsellFunnelID(''));
    dispatch(setPageId(null));
    dispatch(setIsCartApiLoading(false));
  };

  const getPixel = async () => {
    try {
      const pixel: Tracker[] = [];
      const res = await checkoutService.getPixel(input1);
      if (res?.data?.Pixel) {
        if (res?.data?.Pixel?.META?.code) {
          // pixel.push(new MetaTracker(res?.data?.Pixel?.META?.code));
          setMetaTikTokTracker(pre => {
            return {
              ...pre,
              meta: res?.data?.Pixel?.META?.code,
            };
          });
        }
        if (res?.data?.Pixel?.SNAP?.code) {
          pixel.push(new SnapPixelTracker(res?.data?.Pixel?.SNAP?.code));
        }
        if (res?.data?.Pixel?.TIKTOK?.code) {
          // pixel.push(new TikTokTracker(res?.data?.Pixel?.TIKTOK?.code));
          setMetaTikTokTracker(pre => {
            return {
              ...pre,
              tiktok: res?.data?.Pixel?.TIKTOK?.code,
            };
          });
        }
        if (res?.data?.Pixel?.APPLOVIN?.code) {
          pixel.push(new AxonTracker(res?.data?.Pixel?.APPLOVIN?.code));
        }
        if (res?.data?.Pixel?.NEWSBREAK?.code) {
          pixel.push(new NewsBreakTracker(res?.data?.Pixel?.NEWSBREAK?.code));
        }
        if (res?.data?.Pixel?.RETENTION?.code) {
          pixel.push(
            new RetentionPixelTracker(res?.data?.Pixel?.RETENTION?.code),
          );
        }
        if (res?.data?.Pixel?.['TRIPLE-WHALE']?.code) {
          pixel.push(
            new TripleWhaleTracker(res?.data?.Pixel?.['TRIPLE-WHALE']?.code),
          );
        }
        if (
          res?.data?.Pixel?.['GOOGLE-TAG-WITHOUT-GTM']?.code?.length &&
          res?.data?.Pixel?.['GOOGLE-TAG-WITHOUT-GTM']?.label?.length
        ) {
          res?.data?.Pixel?.['GOOGLE-TAG-WITHOUT-GTM']?.code?.map(
            (code: string, index: number) => {
              if (
                code &&
                res?.data?.Pixel?.['GOOGLE-TAG-WITHOUT-GTM']?.label?.[index]
              ) {
                pixel.push(
                  new GoogleAdsTracker(
                    code,
                    res?.data?.Pixel?.['GOOGLE-TAG-WITHOUT-GTM']?.label?.[
                      index
                    ],
                  ),
                );
              }
            },
          );
        }
        if (res?.data?.Pixel?.['GOOGLE-TAG-MANAGER']?.code) {
          if (
            storeData?.ShopID === '9ff43a-25' ||
            storeData?.ShopID === '3bcb9d-c3'
          ) {
            pixel.push(
              new GTMTrackerCustom(
                res?.data?.Pixel?.['GOOGLE-TAG-MANAGER']?.code,
              ),
            );
          } else {
            pixel.push(
              new GTMTracker(res?.data?.Pixel?.['GOOGLE-TAG-MANAGER']?.code),
            );
          }
        }
        //following code is commented for future use or in case we need to use it
        // const eventPublisher = EventPublisher.getInstance();
        // pixel.forEach((tracker: Tracker) => {
        //   tracker.Init();
        //   eventPublisher.subscribeAll(event => {
        //     tracker.TrackEvent(event);
        //   });
        // });
      }
      if (shopId && thankyouPagePixelStoreIds?.includes(shopId)) {
        pixel.push(new GTMTrackerForThakyouPage(['GTM-PK7LFVSH']));
      }

      setPixelEvent(pixel);
    } catch (error) {
      console.error('Error in intializing pixel data:', error);
    }
  };

  const handlePreloadError = (error: AxiosError) => {
    if (error?.response?.data) {
      const { StatusCode, Msg } = error?.response?.data as {
        StatusCode: number;
        Msg: string;
      };
      if (StatusCode === 404 && Msg === 'Cart is empty' && storeData?.ShopURL) {
        window.location.href = `https://${storeData.ShopURL}`;
      } else if (
        error?.response?.status === 400 ||
        error?.response?.status === 404
      ) {
        setError(
          'There was a problem with your request. Please check your information and try again.',
        );
      } else {
        setError(
          'Something went wrong! Try refreshing the page or try again later!',
        );
      }
    } else {
      console.error('Error in handlePreloadError', error);
      setError(
        'Something went wrong! Try refreshing the page or try again later!',
      );
    }
  };

  const checkConfigData = (pageData: string, pageType: string) => {
    const configData = ConvertBase64ToJson(pageData);
    if (!isEmpty(configData)) {
      setPuckData(configData);
      let puckConfig;
      if (
        [
          PageType.UPSELL,
          PageType.CHECKOUT,
          PageType.CONFIRMATION,
          PageType.OTHER,
        ].includes(pageType)
      ) {
        puckConfig = checkoutConfig() as Config;
      } else {
        setError(
          'There was a problem with your request. Please check your information and try again.',
        );
      }
      setPuckConfig(puckConfig);
    }
  };

  const getPostUpSells = async (cartData: Cart) => {
    if (shopId && cartData?.LineItems?.length > 0) {
      const productIds = cartData?.LineItems?.map(
        (cartLine: { ProductID: string }) => cartLine?.ProductID,
      );

      const payload = {
        Limit: 10,
        ProductIDs: productIds,
        ShopID: shopId,
        CartId: cartData?.OriginalCartID?.replace('gid://shopify/Cart/', ''),
      };

      try {
        if (postUpsellPage?.includes(shopId)) {
          const res = await checkoutService.getPostCheckoutUpSells(payload);
          if (res?.status === 200 && res?.data?.Result?.data) {
            dispatch(setPostUpsellData(res.data.Result.data));
          }
        } else {
          const res = await checkoutService.getPostCheckoutUpSellsV2(payload);
          const keys = Object.keys(res.data.Result).filter(
            key => key !== 'smartUpsellFunnelID',
          );
          if (res?.data?.Result?.smartUpsellFunnelID) {
            dispatch(
              setSmartUpsellFunnelID(res.data.Result.smartUpsellFunnelID || ''),
            );
          }
          if (res?.status === 200 && res?.data?.Result) {
            dispatch(setUpsellData(res.data?.Result));
            dispatch(setCurrentUpsellData(res.data?.Result?.[keys[0]]));

            // don't remove this code as it is used for upsell page in upcoming

            if (res?.data?.Result) {
              dispatch(
                setNextPageConfig({
                  id: res.data?.Result?.[keys[0]]?.pageId,
                  pageType: 'upsell',
                  pageVisiblity: '',
                }),
              );
            }
          }
        }
      } catch (error) {
        console.error('Error fetching post-upsell data:', error);
      }
    }
  };

  const getPreUpsell = useCallback(
    async (cartID: string) => {
      try {
        dispatch(setPreUpsellLoading(true));
        if (!shopId) {
          return;
        }

        const payload: GetPreCheckoutUpSellPayload = {
          Limit: 5,
          CartID: cartID,
          ShopID: shopId,
        };
        const res = await checkoutService.getPreCheckoutUpSells(payload);
        if (res?.status === 200 && res?.data?.Result)
          dispatch(setPreUpsellData(res.data.Result));
      } catch (error) {
        console.error('Error fetching pre-upsell data:', error);
      } finally {
        dispatch(setPreUpsellLoading(false));
      }
    },
    [shopId],
  );

  const getStoreData = useCallback(async () => {
    if (!shopId) {
      setError(
        'Something went wrong! Try refreshing the page or try again later!',
      );
      return;
    }
    try {
      setLoading(pre => pre + 1);
      const res = await checkoutService.getStoreDetails(
        shopId,
        eventToken || '',
        true,
      );
      if (res?.status === 200 && res?.data) {
        if (isMockApi) {
          res.data.IsCardEncryption = false;
        }
        dispatch(setStoreData(res?.data));
      } else {
        dispatch(
          setStoreData({
            ...storeData,
            ShopID: '',
            StoreID: '',
            ShopURL: '',
            CustomerServiceEmail: '',
            CustomerServiceNumber: '',
          }),
        );
      }
    } catch (error) {
      handlePreloadError(error as AxiosError);
    } finally {
      setLoading(pre => pre - 1);
    }
  }, [shopId, handlePreloadError]);

  const getPageDetails = async () => {
    try {
      if (!shopId || !funnelishId) {
        showNotification(
          StatusCode.failed,
          `Invalid ${shopId ? '' : 'shop Id'}  ${funnelishId ? '' : 'funnelish Id'}`,
        );
        return;
      }
      setLoading(pre => pre + 1);

      if (navStateID && purchaseToken) {
        const id =
          navStateID +
          (state?.pageVisiblity === 'DEFAULT'
            ? `?templateID=${navStateID}`
            : '');
        const { data, status } = await checkoutService.getPageById(id);

        if (status === 200 && data?.Result) {
          checkConfigData(data?.Result?.pageData, data?.Result?.pageType);
          dispatch(
            setNextPageConfig({
              id: data?.Result?.nextPage?.id || '',
              pageType: data?.Result?.nextPage?.pageType || '',
              pageVisiblity: data?.Result?.nextPage?.pageVisiblity || '',
            }),
          );
        }
      } else {
        getPixel();
        resetState();
        const { data, status } = await checkoutService.getFunnelishPageById(
          funnelishId,
          shopId,
        );

        if (status === 200 && data?.Result) {
          dispatch(
            setCurrentPageFunnelId(data?.Result?.Page?.funnelMappingId || ''),
          );
          dispatch(setPageId(data?.Result?.Page?.id || null));
          dispatch(
            setNextPageConfig({
              id: data?.Result?.Page?.nextPage?.id || '',
              pageType: data?.Result?.Page?.nextPage?.pageType || '',
              pageVisiblity: data?.Result?.Page?.nextPage?.pageVisiblity || '',
            }),
          );
          checkConfigData(
            data?.Result?.Page?.pageData,
            data?.Result?.Page?.pageType,
          );
        }
      }
    } catch (error) {
      console.error('Error in getting page details', error);
      const errorResponse = error as IErrorResponse<AxiosError>;
      handlePreloadError?.(errorResponse.error as AxiosError);
    } finally {
      setLoading(pre => pre - 1);
    }
  };
  const getCartDetails = async () => {
    try {
      if (!shopId || !funnelishId) {
        return;
      }
      dispatch(setIsCartApiLoading(true));
      const res = await checkoutService.getCartDetails(
        funnelishId,
        shopId,
        cartId || undefined,
      );
      if (!searchParams.get('cart')) {
        const newSearchParams = new URLSearchParams(searchParams);
        newSearchParams.set(
          'cart',
          res?.data?.Result?.Cart?.OriginalCartID?.replace(
            'gid://shopify/Cart/',
            '',
          ) || '',
        );
        window.history.replaceState(
          {},
          '',
          `${window.location.pathname}?${newSearchParams.toString()}`,
        );
      }
      if (res?.status === 200 && res?.data?.Result) {
        // Get the current global shipping data directly
        const currentShippingData = globalShippingData;
        dispatch(
          setCartData({
            ...res?.data?.Result?.Cart,
            PhoneNumber:
              currentShippingData?.PhoneNumber ||
              cartData?.PhoneNumber ||
              res?.data?.Result?.Cart?.PhoneNumber ||
              '',
            Email:
              currentShippingData?.Email &&
              /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(currentShippingData.Email)
                ? currentShippingData.Email
                : res?.data?.Result?.Cart?.Email ||
                  (cartData?.Email &&
                  /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(cartData.Email)
                    ? cartData.Email
                    : res?.data?.Result?.Cart?.Email) ||
                  currentShippingData?.Email ||
                  '',
            ShippingAddress: {
              ...res?.data?.Result?.Cart?.ShippingAddress,
              Address1:
                currentShippingData?.Address1 ||
                cartData?.ShippingAddress?.Address1 ||
                res?.data?.Result?.Cart?.ShippingAddress?.Address1 ||
                '',
              Address2:
                currentShippingData?.Address2 ||
                cartData?.ShippingAddress?.Address2 ||
                res?.data?.Result?.Cart?.ShippingAddress?.Address2 ||
                '',
              City:
                currentShippingData?.City ||
                cartData?.ShippingAddress?.City ||
                res?.data?.Result?.Cart?.ShippingAddress?.City ||
                '',
              CountryCode:
                currentShippingData?.CountryCode ||
                cartData?.ShippingAddress?.CountryCode ||
                res?.data?.Result?.Cart?.ShippingAddress?.CountryCode ||
                '',
              FirstName:
                currentShippingData?.FirstName ||
                cartData?.ShippingAddress?.FirstName ||
                res?.data?.Result?.Cart?.ShippingAddress?.FirstName ||
                '',
              LastName:
                currentShippingData?.LastName ||
                cartData?.ShippingAddress?.LastName ||
                res?.data?.Result?.Cart?.ShippingAddress?.LastName ||
                '',
              Organization:
                currentShippingData?.Organization ||
                cartData?.ShippingAddress?.Organization ||
                res?.data?.Result?.Cart?.ShippingAddress?.Organization ||
                '',
              ProvinceCode:
                currentShippingData?.ProvinceCode ||
                cartData?.ShippingAddress?.ProvinceCode ||
                res?.data?.Result?.Cart?.ShippingAddress?.ProvinceCode ||
                '',
              Zip:
                currentShippingData?.Zip ||
                cartData?.ShippingAddress?.Zip ||
                res?.data?.Result?.Cart?.ShippingAddress?.Zip ||
                '',
            },
          }),
        );

        dispatch(
          setAvailableShippingMethods(
            res?.data?.Result?.Cart
              ?.AvailableShippingMethods as ShippingMethod[],
          ),
        );
        if (res?.data?.Result?.Cart?.AvailableShippingMethods?.length) {
          dispatch(
            setSelectedShippingMethod(
              res?.data?.Result?.Cart?.AvailableShippingMethods?.[0],
            ),
          );
        }
        dispatch(setCallMetaApi(res?.data?.Result?.CallMetaApi));
        dispatch(setSalexTaxEnabled(res?.data?.Result?.salesTaxEnabled));
        dispatch(
          setCalculatedFeeEnabled(res?.data?.Result?.calculatedFeeEnabled),
        );
        const uniqueEventId = uuidv4();
        publish('InitiateCheckout', {
          eventName: 'InitiateCheckout',
          eventId: uniqueEventId,
          shopId: shopId,
          cart: res?.data?.Result?.Cart,
          isFunnelish: true,
        });
        publish('PageView', {
          eventName: 'PageView',
          eventId: uniqueEventId,
          shopId: shopId,
          cart: res?.data?.Result?.Cart,
        });
        setPixelData({
          isEventHoisted: false,
          phxRequestId: uniqueEventId,
        });
        if (res?.data?.Result?.CallMetaApi) {
          handleCapi({
            eventName: 'InitiateCheckout',
            ShopID: shopId,
            Cart: res?.data?.Result?.Cart,
            eventId: uniqueEventId,
            isFunnelish: true,
          });
        }
        if (res?.data?.Result?.ApplePay) {
          dispatch(setApplePay(res?.data?.Result?.ApplePay));
        }
        if (res?.data?.Result?.GooglePay) {
          dispatch(setGooglePay(res?.data?.Result?.GooglePay));
        }
      }
      getPreUpsell?.(
        res?.data?.Result?.Cart?.OriginalCartID?.replace(
          'gid://shopify/Cart/',
          '',
        ),
      );
      getPostUpSells?.(res?.data?.Result?.Cart);
    } catch (error) {
      console.error('Error in getting cart details', error);
      const errorResponse = error as IErrorResponse<AxiosError>;
      handlePreloadError?.(errorResponse.error as AxiosError);
    } finally {
      dispatch(setIsCartApiLoading(false));
    }
  };
  useEffect(() => {
    getStoreData();
    getPageDetails();
    getCartDetails();
  }, [searchParams, state]);

  extractAndUseTrackers(
    puckRootData?.pixelTracking,
    puckData != undefined,
    puckRootData?.isGlobalPixel || isThankYouPage,
    setPixelData,
    pixelEvent,
    metaTickTokTracker,
    pixelData?.phxRequestId,
  );

  useEffect(() => {
    if (
      pixelData?.isEventHoisted &&
      pixelData?.phxRequestId &&
      shopId &&
      cartData
    ) {
      publish('InitiateCheckout', {
        eventName: 'InitiateCheckout',
        eventId: pixelData?.phxRequestId,
        shopId: shopId,
        cart: cartData,
        isFunnelish: true,
      });
      setPixelData({
        isEventHoisted: false,
        phxRequestId: '',
      });
    }
  }, [pixelData?.isEventHoisted, shopId, cartData]);

  return (
    <>
      {loading ? (
        <CheckoutSkeleton />
      ) : error ? (
        <ErrorMessage errorMessage={error} />
      ) : (
        puckConfig &&
        puckData && <HomePage config={puckConfig} data={puckData} />
      )}
    </>
  );
};

export default Funnelish;
